import { useCallback, useMemo } from 'react'
import { useHistory } from 'react-router'
import { authApi, postApi } from '@api/api'
import {
  setItemToStorage,
  getItemFromStorage,
  removeItemToStorage,
} from '@utils/storage'
import { LOGIN, LOGOUT, GET_USER, GET_USER_POST } from './types'

const actions = dispatch => {
  const history = useHistory()

  useMemo(async () => {
    const user = getItemFromStorage('user', null)
    const token = getItemFromStorage('token', null)

    dispatch({ type: GET_USER, payload: { user, token } })
  }, [])

  const handleLogin = useCallback(async userInfo => {
    const { resData } = await authApi.login(userInfo)

    try {
      setItemToStorage('user', resData.user)
      setItemToStorage('token', resData.token)
      dispatch({ type: LOGIN, payload: resData })
      history.push('/main')
    } catch (e) {
      alert('로그인에 실패하였습니다!')
    }
  }, [])

  const handleLogout = useCallback(async () => {
    await authApi.logout()

    removeItemToStorage('user')
    removeItemToStorage('token')
    dispatch({ type: LOGOUT, payload: { user: null, token: null } })
    history.push('/')
  }, [])

  const handleSignup = useCallback(async userInfo => {
    const { resData } = await authApi.signUp(userInfo)

    try {
      setItemToStorage('user', resData.user)
      setItemToStorage('token', resData.token)
      dispatch({ type: LOGIN, payload: resData })
      history.push('/main')
    } catch (e) {
      alert('로그인에 실패하였습니다!')
    }
  })

  const handleGetUser = useCallback(async () => {
    const { resData } = await authApi.getAuthUser()

    try {
      setItemToStorage('user', resData)
      dispatch({ type: GET_USER, payload: { user: resData } })
    } catch (e) {
      alert('사용자 조회에 실패했습니다!')
    }
  }, [])

  const handleGetUserPost = useCallback(async ({ user, params }) => {
    const { resData } = await postApi.getUserPostList(user._id, params)

    user.posts = resData
    setItemToStorage('user', user)
    dispatch({ type: GET_USER_POST, payload: { user } })
  }, [])

  return {
    handleLogin,
    handleLogout,
    handleSignup,
    handleGetUser,
    handleGetUserPost,
  }
}

export default actions
